import HeroSection from './HeroSection';
import ServiciosIndex from './ServiciosIndex';
import DetalleServicio from './DetalleServicio';

// Este objeto asocia el ID del slice en Prismic con el componente de React local
export const components = {
  hero_section: HeroSection,
  servicios_index: ServiciosIndex,
  detalle_servicio: DetalleServicio,
};
